<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="search">
              <b-row>
                <b-col sm="4">
                  <b-form-group >
                    <label for="nom"><strong>Nom</strong></label>
                    <b-form-input type="text" id="nom" v-model="nom" :class="{hasError: errors.nom !== ''}"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="prenom"><strong>Prénom</strong></label>
                    <b-form-input type="text" id="prenom" v-model="prenom" :class="{hasError: errors.prenom !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.prenom }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group >
                    <label for="email"><strong>Email</strong></label>
                    <b-form-input type="text" id="email" v-model="email" :class="{hasError: errors.email !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.email }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label="Profil" label-for="profilSelect">
                    <b-form-select
                      id="profilSelect"
                      :plain="true"
                      :options="profilsOptions"
                      v-model="selectedProfil"
                    ></b-form-select>
                        <span class="field-error">{{ errors.selectedProfil }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label="Structure" label-for="structureSelect">
                  <b-form-select
                      id="structureSelect"
                      :plain="true"
                      :options="structuresOptions"
                      v-model="selectedStructure"
                  />
                  </b-form-group>
                  <span class="field-error">{{ errors.selectedStructure }}</span>
                </b-col>
                <b-col sm="4" style="margin-top:32px">
                  <b-form-group>
                    <b-form-checkbox
                      id="checkbox-active"
                      v-model="includeDesactivate"
                      name="isActive"
                      value=true
                      unchecked-value=false
                      switch>
                        Inclure les utilisateurs désactivés
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des utilisateurs</strong>
        <b-button
          type="button"
          @click="editUser('add')"
          class="pull-right"
          size="md"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Ajouter un utilisateur
        </b-button>
      </b-card-header>
      <b-card-body>
        <v-client-table ref="resultTable" :columns="columns" :data="items" :options="options">
          <span slot="profil_active" slot-scope="props">{{ getDisplayProfil(props.row) }}</span>
          <span slot="structure" slot-scope="props">{{ props.row.structure.libelle }}</span>
          <div slot="action" slot-scope="props">
            <i class="fa fa-edit mr-2 text-primary fa-1_5x clickable" @click="editUser('edit', props.row.id)"></i>
            <!-- <b-button
              type="button"
              @click="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2"
              v-if="props.row.is_active"
            >
              <i class="fa fa-trash mr-3 clickable" @click="destroy(props.row.id)"></i> Désactiver
            </b-button> -->
            <i v-if="props.row.is_active" class="fa fa-trash clickable text-danger" @click="destroy(props.row.id)"></i>
            <!-- <b-button
              type="button"
              @click="editUser('edit', props.row.id)"
              class="badge badge-primary p-2"
            >
              <i class="fa fa-edit"></i> Modifier
            </b-button> -->
          </div>
          <div slot="num_nsi" slot-scope="props" v-html="getNumNsi(props.row)">

          </div>
          <div slot="date_debut" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ getDisplayDateDebut(props.row) }}</span>
          </div>
          <div slot="date_fin" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ getDisplayDateFin(props.row) }}</span>
          </div>
          <div v-if="props.row.date_connexion" slot="date_connexion" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_connexion) }}</span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button
          type="button"
          @click="editUser('add')"
          class="pull-right"
          size="md"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Ajouter un utilisateur
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../../utils/auth";
import { Event } from 'vue-tables-2';

export default {
  data() {
    return {
      nom: "",
      prenom: "",
      email: "",
      profil: "",
      structure: "",
      structuresOptions: [],
      selectedStructure: "",
      includeDesactivate: false,
      profilsOptions: [],
      selectedProfil: "Tous",
      noSearch: 'noSearch',
      activeFilter: "",
      columns: [
        "nom",
        "prenom",
        "email",
        "structure",
        "profil_active",
        'num_nsi',
        "date_debut",
        "date_fin",
        "date_connexion",
        "action"
      ],
      items: [],
      options: {
        headings: {
          num_nsi: 'N° User\nN° Acteur',
          nom: "Nom",
          prenom: "Prénom",
          email: "Email",
          structure: "Structure",
          profil_active: "Profil",
          date_debut: "Date début",
          date_fin: "Date fin",
          date_connexion: "Date login",
          action: "Action"
        },
        columnsClasses: {
          num_nsi: "pre-formatted",
          date_debut: "date-header",
          date_fin: "date-header",
          date_connexion: "date-header",
          action: "action-xs"
        },
        rowClassCallback(row) {
          if(row.is_active == false){
            return "desactive";
          }else if(row.profil_active[0] == undefined && row.profil_futur != undefined){
            return "inactive";
          }else if(row.is_active == true && row.dateDebut == ''){
            return "inactive";
          } else {
            return "";
          }

        },
        // filterByColumn: true,
        sortable: ["nom", "prenom","email","date_debut","date_fin","date_connexion","structure","created_at"],
        filterable: ["nom", "prenom", "email"],
        perPage: 10,
        perPageValues: [10, 50, 500],
        texts: {
          filterPlaceholder: "Nom, Prénom, Email"
        },
        orderBy: { column: "created_at", ascending: false }
      },
      errors: {
        nom: "",
        prenom: "",
        email: "",
        profil: "",
        structure: "",
        selectedProfil: "",
        selectedStructure: "",
      }
    };
  },
  mounted() {
    this.search()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.allHabilitations();
    this.getStructures();

    if (this.$route.query.no) {
      this.nom = this.$route.query.no
    }
    if (this.$route.query.pre) {
      this.prenom = this.$route.query.pre
    }
    if (this.$route.query.em) {
      this.email = this.$route.query.em
    }
    if (this.$route.query.pro) {
      this.selectedProfil = this.$route.query.pro
    }
    if (this.$route.query.st) {
      this.selectedStructure = this.$route.query.st
    }
    if (this.$route.query.inc) {
      this.includeDesactivate = this.$route.query.inc
    }
    if (this.$route.query.fil) {
      this.activeFilter = this.$route.query.fil
      this.$refs.resultTable.setFilter(this.activeFilter)
    }
  },
  methods: {
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/administration/users")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.users;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    allHabilitations() {
      // Récupérer la liste de tous les profils
      this.$axios
        .get("/administration/profiles")
        .then(response => {
          let profils = response.data.profils;
          for (let key in profils){
            if (this.profilsOptions.indexOf(profils[key].libelle) < 0){
              this.profilsOptions.push({
                text: profils[key].libelle,
                value: profils[key].id
              });
            }
          }
          this.profilsOptions.sort();
          this.profilsOptions.unshift('Tous');
        })
        .catch(function(error) {});
    },
    search() {
      this.noSearch = ''
      let self = this;
      let dataPost = {}
      dataPost.includeDesactivate = this.includeDesactivate
      dataPost.nom = this.nom
      dataPost.prenom = this.prenom
      dataPost.email = this.email
      dataPost.profil = this.selectedProfil
      dataPost.structure = this.selectedStructure
      dataPost.noSearch = this.noSearch

      this.$store.commit("IS_LOADING", true);
      this.$axios
        .post("/administration/users/search", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.users
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
      let self = this
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment désactiver cet utilisateur ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Désactiver"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true);
            this.$axios
              .post("/administration/users/desactivate/" + id)
              .then(response => {
                this.$store.commit("IS_LOADING", false);
                this.$swal({
                  position: "top",
                  type: "success",
                  title: "Désactivation avec succès",
                  text: "L'utilisateur a bien été désactivé",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.all();
              })
              .catch(function(error) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          }
        });
    },
    editUser(to, id) {
      // console.log('activeFilter : ' + this.activeFilter)
      if (to === "edit") {
        this.$router.push({ path: "/administration/users/edit/" + id, query: { inc: this.includeDesactivate, fil: this.activeFilter, no: this.nom, pre: this.prenom, em: this.email, pro: this.selectedProfil, st: this.selectedStructure }});
      } else if (to === "add") {
        this.$router.push({ path: "/administration/users/add" });
      }
    },
    clearForm() {
      this.nom = ''
      this.prenom = ''
      this.email = ''
      this.selectedProfil = 'Tous'
      this.selectedStructure = ''
      this.includeDesactivate = false
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    getDisplayProfil(user){
      if(user.profil_active[0] != undefined){
        return user.profil_active[0].libelle;
      }else if(user.profil_futur != undefined){
        return user.profil_futur.libelle;
      }else{
        return "";
      }
    },
    getDisplayDateDebut(user){
      if(user.profil_active[0] != undefined){
        return this.formatDate(user.dateDebut);
      }else if(user.profil_futur != undefined){
        return this.formatDate(user.profil_futur.date_debut);
      }else{
        return "";
      }
    },
    getDisplayDateFin(user){
      if(user.profil_active[0] != undefined){
        if(user.dateFin){
          return this.formatDate(user.dateFin);
        }else{
          return "";
        }
      }else if(user.profil_futur != undefined){
        return this.formatDate(user.profil_futur.date_fin);
      }else{
        return "";
      }
    },
    getStructures() {
      this.$axios
        .get("/administration/structures")
        .then(response => {
          for(let structures of response.data.structures){
            this.structuresOptions.push({value: structures.id, text: structures.libelle})
          }
        })
        .catch(() => {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un probléme est survenue, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    getNumNsi(user) {
      let numUser = user.nsi_numero_user ? user.nsi_numero_user : '-';
      let numActeur = user.nsi_numero_acteur ? user.nsi_numero_acteur : '-';
      return numUser + '<br>' + numActeur;
    },
  }
};
</script>

<style>
</style>
